export * from '#core/views';

import { parseView } from '#core/lib/view';
import { DataModel as CoreDataModel } from '#core/views';

import { CompletionModel } from '#schema/model/CompletionModel';
import { FieldModel } from '#schema/model/FieldModel';
import { PlatformModel } from '#schema/model/PlatformModel';
import { ReservoirModel } from '#schema/model/ReservoirModel';
import { ScaleDiscoveryModel } from '#schema/model/ScaleDiscoveryModel';
import { WellboreGeometryModel } from '#schema/model/WellboreGeometryModel';
import { WellModel } from '#schema/model/WellModel';
import { WellStringModel } from '#schema/model/WellStringModel';

export const DataModel = {
  ...CoreDataModel,
  IpsoScale: {
    externalId: 'dm_adnoc_ipso_scale',
    space: 'sp_adnoc_ipso_scale',
  },
} as const;

export const CompletionView = parseView({
  view: { externalId: 'Completion' },
  model: CompletionModel,
  dataModel: DataModel.IpsoScale,
});
export const FieldView = parseView({
  view: { externalId: 'Field' },
  model: FieldModel,
  dataModel: DataModel.IpsoScale,
});
export const PlatformView = parseView({
  view: { externalId: 'Platform' },
  model: PlatformModel,
  dataModel: DataModel.IpsoScale,
});
export const ReservoirView = parseView({
  view: { externalId: 'Reservoir' },
  model: ReservoirModel,
  dataModel: DataModel.IpsoScale,
});
export const ScaleDiscoveryView = parseView({
  view: { externalId: 'ScaleDiscovery' },
  model: ScaleDiscoveryModel,
  dataModel: DataModel.IpsoScale,
});
export const WellView = parseView({ view: { externalId: 'Well' }, model: WellModel, dataModel: DataModel.IpsoScale });
export const WellStringView = parseView({
  view: { externalId: 'WellString' },
  model: WellStringModel,
  dataModel: DataModel.IpsoScale,
});
export const WellboreGeometryView = parseView({
  view: { externalId: 'WellboreGeometry' },
  model: WellboreGeometryModel,
  dataModel: DataModel.IpsoScale,
});
